import { defineStore } from "pinia";
import { ref } from "vue";
import DOMPurify from "dompurify";

export const useAppStore = defineStore("AppStore", () => {
  const pageHtml = ref(null);
  const drawer = ref(false);
  const termsAndConditionsAcceptedFlag = "terms_and_conditions_accepted";

  // Estado reactivo para términos aceptados
  const termsAccepted = ref(
    typeof window !== "undefined" &&
      localStorage.getItem(termsAndConditionsAcceptedFlag) === "true"
  );

  const checkLocalStorageForTerms = () => {
    if (typeof window === "undefined") return false;
    return termsAccepted.value;
  };

  function acceptTerms() {
    if (typeof window === "undefined") return;
    localStorage.setItem(termsAndConditionsAcceptedFlag, "true");
    termsAccepted.value = true;
  }

  function declineTerms() {
    if (typeof window === "undefined") return;
    localStorage.setItem(termsAndConditionsAcceptedFlag, "false");
    termsAccepted.value = false;
  }

  const pageHtmlLang = ref(null);
  let fetchPageContentPromise = null;
  let fetchPageContentLang = null;

  const fetchPageContent = async (lang) => {
    const langSuffix = lang === "es" ? "es" : "en";
    // Evitar re-fetch si ya tenemos el HTML para este idioma
    if (pageHtmlLang.value === langSuffix && pageHtml.value) return;
    // Evitar llamadas simultáneas al mismo idioma
    if (fetchPageContentPromise && fetchPageContentLang === langSuffix) return fetchPageContentPromise;

    fetchPageContentLang = langSuffix;
    fetchPageContentPromise = (async () => {
      try {
        const url = `${import.meta.env.VITE_BASE_URL_DISCLAIMER}/informacion-tcalidad-${langSuffix}.html`;
        const response = await fetch(url);
        const html = await response.text();
        // Solo actualizar si el idioma solicitado sigue siendo el actual
        if (fetchPageContentLang === langSuffix) {
          pageHtml.value = typeof window !== "undefined" ? DOMPurify.sanitize(html) : html;
          pageHtmlLang.value = langSuffix;
        }
      } catch {
        // Error cargando archivo HTML
      } finally {
        if (fetchPageContentLang === langSuffix) {
          fetchPageContentPromise = null;
        }
      }
    })();

    return fetchPageContentPromise;
  };

  return {
    drawer,
    termsAccepted,
    checkLocalStorageForTerms,
    acceptTerms,
    declineTerms,
    pageHtml,
    fetchPageContent,
  };
});
